<script lang="ts">
    import src from './svg/person_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
</script>

<!--              style="filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(24deg) brightness(106%) contrast(101%);"-->

<TemplateIcon {src} {scale} alt="Account" on:click />
